import { isPlayerSupported, create } from 'amazon-ivs-player';

import wasmBinaryPath from 'amazon-ivs-player/dist/assets/amazon-ivs-wasmworker.min.wasm';
import wasmWorkerPath from 'amazon-ivs-player/dist/assets/amazon-ivs-wasmworker.min.js';

const createAbsolutePath = (assetPath) => new URL(assetPath, document.URL).toString();

export const createIVSPlayer = () => {
    if (isPlayerSupported) {
        return create({
            wasmWorker: createAbsolutePath(wasmWorkerPath),
            wasmBinary: createAbsolutePath(wasmBinaryPath),
        });
    }

    return null;
};

export default createIVSPlayer;